module.exports = __webpack_public_path__ + "img/fleet-purple.44236f48.svg";